"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateVectors = void 0;
const generateVectors = ({ getNthVector, vectorsCount }) => {
    return Array.from({ length: vectorsCount }, (_, index) => getNthVector(index));
};
exports.generateVectors = generateVectors;
